var Swiper = require('swiper');

$(function() {
	if ($('.ticket-slider').length > 0) {
		var ticket_slider = new Swiper('.ticket-slider', {
			slidesPerView: 'auto',
			spaceBetween: 15,
			loop: true,
			loopedSlides: 20,
			autoplay: 4000,
			allowTouchMove: true,
			rtl: true,
			effect: 'slide',
			keyboardControl: true,
			autoplayDisableOnInteraction: false,
			observer: true,
			observeParents: true,
			nextButton: '.ticket-slider__navigation--next',
			prevButton: '.ticket-slider__navigation--prev',
			breakpoints: {
				800: {
					slidesPerView: 2.5,
					centeredSlides: true
				},
				500: {
					slidesPerView: 1.6,
					centeredSlides: true
				}
			}
		});

		$('.ticket-slider').hover(function() {
			ticket_slider.stopAutoplay();
		}, function() {
			ticket_slider.startAutoplay();
		});
	}
});